import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../auth.scss";
import { Input } from "common/InputForm";
import { loginApi } from "services/auth";
import commonMessage from "../../../utils/commonMessage";
import { regex } from "utils/formValidator";
import { toastMessage } from "utils/toastMessage";
import useButtonLoader from "common/UseButtonLoader";
import UsePasswordToggle from "common/UsePasswordToggle";
import {
  UseInputValidationDebounce,
  validateEmail,
} from "common/UseInputValidationDebounce";
import { authImg, LogoImg } from "assets/images";
import { Button } from "@mui/material";
import { CustomButton } from "components/form";
import { LogoImg2 } from "../../../assets/images";
import { setPersonalInfo } from "store/slices/userDataStore";
import { useDispatch } from "react-redux";
const LoginPage = ({ setSteps, data, setData }) => {
  const navigate = useNavigate();

  console.log(data, "loginData");
  const { EMAIL_NOT_FOUND, VALID_EMAIL, PASSWORD_NOT_FOUND, VALID_PASSWORD } =
    commonMessage;
  const { email, password } = regex;
  const [loginField, setLoginField] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [buttonLoader, setButtonLoader] = useButtonLoader("Login");
  const [inputType, icon] = UsePasswordToggle();
  const dispatch = useDispatch();
  // *---------------Input Handler------------*//
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setLoginField({ ...loginField, [name]: value });
  };

  // *-------------------Debounce input validation checking-------------* //
  // const debouncedValidateEmail = UseInputValidationDebounce(validateEmail, 800);

  // useEffect(() => {
  //   if (loginField.email) {
  //     debouncedValidateEmail(loginField.email,setErrors,errors);
  //   }
  // }, [loginField.email,setErrors,errors]);
  // *---------------Validation------------*//
  const validation = () => {
    let status = true;
    const error = {};
    if (!loginField.email) {
      error["email"] = EMAIL_NOT_FOUND;
      status = false;
    } else if (!loginField?.email.match(email)) {
      error["email"] = VALID_EMAIL;
      error["emailErr"] = true;
      status = false;
    }
    if (!loginField.password) {
      error["password"] = PASSWORD_NOT_FOUND;
      status = false;
    }
    setErrors(error);
    return status;
  };
  const loginHandler = async () => {
    if (validation()) {
      try {
        setButtonLoader(true);
        const res = await loginApi(loginField);
        if (res) {
          if (res?.data?.status === 200) {
            toastMessage(res?.data?.message, "success", "login");
            setData(res?.data?.data.user);
            const savePersonalInfo = {
              ...res?.data?.data?.user,
              isAdmin: res?.data?.data?.user.toString(),
            };
            navigate("/dashboard");
            localStorage.setItem("token", res?.data?.data?.token);
            localStorage.setItem("admin", JSON.stringify(savePersonalInfo));
            localStorage.setItem("adminInfo",JSON.stringify(res?.data?.data?.user));
            dispatch(setPersonalInfo({ personalInfo: savePersonalInfo }));
          } else {
            toastMessage(res?.data?.message, "warning", "login");
          }
        }
      } catch (e) {
        console.log("error", e);
      } finally {
        setButtonLoader(false);
      }
    }
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      loginHandler();
    }
  };
  return (
    <>
      <form>
        <div className="form_title">
          <img src={LogoImg2} alt="" />
          <h2>Login to Fashion</h2>
        </div>
        <div className="content">
          <div className="form_field">
            <Input
              className={"form-control input"}
              type={"email"}
              value={loginField.email}
              onChange={onChangeHandler}
              label={"Email Address"}
              placeholder={"Enter email address"}
              name={"email"}
              error={errors?.email}
              extraErr={errors.emailErr}
              onKeyPress={handleKeyPress}
            />
          </div>
          <div className="form_field has_icon">
            <Input
              className={"form-control input"}
              type={inputType}
              value={loginField.password}
              onChange={onChangeHandler}
              label={"Password"}
              placeholder={"Enter Password"}
              name={"password"}
              error={errors?.password}
              onKeyPress={handleKeyPress}
            />
            <span className="password_icons">{icon}</span>
          </div>
          <div className="button_wrap">
            <button
              type="button"
              ref={buttonLoader}
              className="w-100 button"
              onClick={loginHandler}
            >
              Login
            </button>
            {/* <CustomButton
             type="button"
              // ref={buttonLoader}
              className="button w-100"
              onClick={loginHandler}
            >
              Login
            </CustomButton> */}

            <Link
              to=""
              // onClick=
              // {forgotPassword}
              onClick={() => setSteps(3)}
            >
              Forgot Password?
            </Link>
          </div>
        </div>
      </form>
    </>
  );
};

export default LoginPage;
